import { useContext } from 'react'
import { ContractStoreContext } from './ContractStoreProvider'
const useContractStore = () => useContext(ContractStoreContext)
export default useContractStore
